/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * description: |-
 *   * `POWER_LINE` - Elektrické vedení
 *   * `ELECTRONIC_COMMUNICATION` - Elektronické komunikace
 *   * `PIPELINE` - Plynovod
 *   * `WATER_SUPPLY` - Vodovod
 *   * `WATER_INLETS` - Přivaděče vody
 *   * `SEWERAGE` - Kanalizace
 *   * `PRODUCT_PIPELINE` - Produktovod
 *   * `HEAT_PIPE` - Teplovod
 *   * `TUBE_MAIL` - Potrubní pošta
 *   * `WASTE_MANAGEMENT` - Odpadové hospodářství
 *   * `SOIL_AMELIORATION` - Meliorace
 *   * `ALL_UTILITIES` - Vše
 * ```
 */
export const UtilitiesTypeEnum = {
  POWER_LINE: 'POWER_LINE',
  ELECTRONIC_COMMUNICATION: 'ELECTRONIC_COMMUNICATION',
  PIPELINE: 'PIPELINE',
  WATER_SUPPLY: 'WATER_SUPPLY',
  WATER_INLETS: 'WATER_INLETS',
  SEWERAGE: 'SEWERAGE',
  PRODUCT_PIPELINE: 'PRODUCT_PIPELINE',
  HEAT_PIPE: 'HEAT_PIPE',
  TUBE_MAIL: 'TUBE_MAIL',
  WASTE_MANAGEMENT: 'WASTE_MANAGEMENT',
  SOIL_AMELIORATION: 'SOIL_AMELIORATION',
  ALL_UTILITIES: 'ALL_UTILITIES',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type UtilitiesTypeEnum = ValuesOf<typeof UtilitiesTypeEnum>;

export type UtilitiesTypeEnumRequest = UtilitiesTypeEnum;
export type UtilitiesTypeEnumResponse = UtilitiesTypeEnum;
